import { useEffect, useState } from "react";

export const useTableColumns = (filters: any, currentColumnIndex: number) => {
    const days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

    const getVisibleColumns = () => {
        const cols = [...days, 'week'];

        if (filters?.pendingBalance) cols.push('pending');
        if (filters?.depositsWithdrawals) cols.push('depositsWithdrawal');

        return cols;
    };

    const visibleColumns = getVisibleColumns();

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isVisible = (colName: string) => {
        const index = visibleColumns.indexOf(colName);
        return !isMobile || currentColumnIndex === index;
    };

    return {
        visibleColumns,
        isVisible,
        isMobile
    };
};